export default {
    state: {
        arr: {}
    },
    getters:{
        AGE: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_AGE: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_AGE_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_AGE: (context, payload) => {
             context.commit('SET_AGE',payload)
        },
        SET_AGE_ACTUAL: (context, actual) => {
            context.commit('SET_AGE_ACTUAL',actual)
        }
    },

}